module.exports = __webpack_public_path__ + "img/c01_unitstartechlaminararmor_Normal_ua.c6570da3.webp";